import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

import ManagerBreadCrumbs from 'components/ManagerBreadCrumbs'
import { getRoutes, extractFavorites } from 'services/Utilities'
import { openModal } from 'store/actions/modals'
import { t } from 'translations'

import { Badge, Button as MerinioButton, Dropdown } from 'ui'

const ManagerNav = ({ pathname }) => {
  const dispatch = useDispatch()
  const { managerNavFavorites } = useSelector(state => state.settings)
  const sortedRoutes = getRoutes('manager', true)

  const { favoriteRoutes, otherRoutes } = extractFavorites(sortedRoutes, managerNavFavorites)

  const ManagerLink = ({ route, hideText, inDropdown }) => {
    const isActive = !(route.dontMatch || []).reduce((acc, dontMatch) => (acc ? true : pathname.includes(dontMatch)), false) && pathname.includes(route.path)

    const RouteContent = (
      <>
        <span className="pr-1">
          <i className={`fad fa-fw fa-${route.icon}`} />
        </span>{' '}
        {!hideText ? t(`manager.${route.title}`) : null}
        {route.isAlpha ? (
          <Badge variant="danger" className="ml-1">
            Alpha
          </Badge>
        ) : null}
        {route.isBeta ? (
          <Badge variant="danger" className="ml-1">
            Beta
          </Badge>
        ) : null}
      </>
    )
    if (!inDropdown)
      return (
        <NavLink className={`nav-link nav-link-sm${isActive ? ' active' : ''}`} to={route.path}>
          {RouteContent}
        </NavLink>
      )
    return (
      <Dropdown.Link to={route.path} className={`${isActive ? ' active' : ''}`}>
        {RouteContent}
      </Dropdown.Link>
    )
  }
  return (
    <nav className="navbar navbar-light navbar-expand-sm bg-white d-none d-md-block p-0" style={{ borderBottom: '1px solid #dfdfdf' }}>
      <ul className="navbar-nav px-2">
        {favoriteRoutes.map(route => {
          return <ManagerLink route={route} key={route.title} hideText={favoriteRoutes.length > 5} />
        })}
        {otherRoutes.length ? (
          <Dropdown className="nav-item" data-display="dynamic">
            <Dropdown.Toggle className="nav-link nav-link-sm"> {t('manager.NAV.OTHER')}</Dropdown.Toggle>
            <Dropdown.Menu direction={favoriteRoutes.length > 1 ? 'right' : undefined} aria-labelledby="navbarDropdown">
              <>
                {otherRoutes.map(route => {
                  return <ManagerLink route={route} key={route.title} inDropdown />
                })}
                <Dropdown.Divider />
              </>
              <Dropdown.Item onClick={() => dispatch(openModal('ManagerNavFavoritesModal'))}>{t('manager.NAV.MANAGE_FAVORITES')}</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ) : favoriteRoutes.length > 4 ? (
          <form className="form-inline ml-auto">
            <MerinioButton color="secondary" size="small" onClick={() => dispatch(openModal('ManagerNavFavoritesModal'))} outlined>
              {t('manager.NAV.MANAGE_FAVORITES')}
            </MerinioButton>
          </form>
        ) : null}
      </ul>
      <ManagerBreadCrumbs />
    </nav>
  )
}

export default ManagerNav
